deepReplace = require 'lib/util/deep-replace'
pluginOptions = require 'views/internal/plugins/plugin-options'
xtend = require 'xtend'

module.exports = (fromPlugin, runCommand) ->
  deepReplace fromPlugin, (value) ->
    if value? && (ref = value._callback)?
      actionFx = (ref, action) ->
        (runOptions = {}) ->
          runCommand xtend runOptions,
            command: 'callback'
            options:
              action: action
              callback: ref
              options: pluginOptions runOptions.options

      fx = actionFx(ref, 'run')
      fx.retain = actionFx(ref, 'retain')
      fx.release = actionFx(ref, 'release')
      fx



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-process-callbacks.coffee